import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button, Form, Modal } from 'react-bootstrap';
import { UserContext } from '../hooks/UserContext';
import Header from '../components/Header';

export default function AdminUsers() {
  const { user } = useContext(UserContext);
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${apiUrl}/users?per_page=100`, {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });
      setUsers(res.data.items);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const resetForm = () => {
    setUsername('');
    setEmail('');
    setPassword('');
    setRole('');
    setError('');
  };

  const handleClose = () => {
    setShowModal(false);
    resetForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post(`${apiUrl}/users`, { username, email, password });
      const newUser = res.data;

      if (role) {
        await axios.put(`${apiUrl}/admin/users/${newUser.id}/role`, { role }, {
          headers: { 'Authorization': `Bearer ${user.token}` }
        });
      }

      setSuccess(`User "${username}" created.`);
      handleClose();
      fetchUsers();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create user.');
    }
  };

  const lastSeenTemplate = (rowData) => {
    if (!rowData.last_seen) return '-';
    return new Date(rowData.last_seen * 1000).toLocaleString('en-GB');
  };

  return (
    <div className="App">
      <Header />
      <div className="container mt-4" style={{ display: 'block' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Users</h2>
          <Button variant="primary" onClick={() => setShowModal(true)}>
            New User
          </Button>
        </div>

        {success && (
          <div className="alert alert-success alert-dismissible" role="alert">
            {success}
            <button type="button" className="close" onClick={() => setSuccess('')}>
              <span>&times;</span>
            </button>
          </div>
        )}

        <DataTable value={users} paginator rows={25} emptyMessage="No users found">
          <Column field="id" header="ID" sortable style={{ width: '6%' }} />
          <Column field="username" header="Username" sortable />
          <Column header="Last Seen" body={lastSeenTemplate} sortable />
        </DataTable>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form.Group controlId="formUsername" className="mb-2">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="username"
            />
          </Form.Group>
          <Form.Group controlId="formEmail" className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="user@example.com"
            />
          </Form.Group>
          <Form.Group controlId="formPassword" className="mb-2">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="password"
            />
          </Form.Group>
          <Form.Group controlId="formRole">
            <Form.Label>Role</Form.Label>
            <Form.Control as="select" value={role} onChange={e => setRole(e.target.value)}>
              <option value="">— none —</option>
              <option value="admin">Admin</option>
              <option value="editor">Editor</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit}>Create</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
